/* buck-personalization-fields.js — variant-pricing pilot (buck).
 * Show the free engraving name/style fields only when a "Personalized" variant is
 * selected (price is handled by the variant itself). Reads the selected
 * "Personalized Text" option directly so it works regardless of Minimog's event layer. */
(function () {
  function block() { return document.querySelector("[data-buck-personalization]"); }
  function nameInput() { return document.getElementById("buck-engraving-name"); }

  // Current "Personalized Text" option value, from whichever control Minimog rendered.
  function selectedValue() {
    var radio = document.querySelector('input[name="Personalized Text"]:checked');
    if (radio) return (radio.value || "").toLowerCase();
    var select = document.querySelector('select[name="options[Personalized Text]"]');
    if (select) return (select.value || "").toLowerCase();
    var container = document.querySelector('[data-option-name="Personalized Text"]');
    if (container && container.getAttribute("data-selected-value")) {
      return container.getAttribute("data-selected-value").toLowerCase();
    }
    return "";
  }

  function update() {
    var on = selectedValue().indexOf("personalized") !== -1;
    var b = block();
    if (b) b.style.display = on ? "" : "none";
    var n = nameInput();
    if (n) { n.required = on; if (!on) n.value = ""; }
  }

  // Re-evaluate whenever the Personalized Text option changes (radios, swatches, select).
  document.addEventListener("change", function (e) {
    if (/personalized text/i.test((e.target && e.target.name) || "")) update();
  });
  // And shortly after, to catch swatch pickers that update async.
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-option-name="Personalized Text"]')) {
      setTimeout(update, 50);
    }
  });

  if (document.readyState !== "loading") update();
  else document.addEventListener("DOMContentLoaded", update);
})();
